import type { BoothDeckConfig } from '../_booth-base/types';

export const LONDON_CONFIG: BoothDeckConfig = {
  slug: 'current-summit-london-booth',
  titleEyebrow: 'Current Summit · London · May 2026 · Booth',
  context: 'Current Summit · London 2026 · Confluent sponsor booth',
  description:
    'StreamNative booth deck for Current Summit London 2026 — Lakestream Platform, Ursa for Kafka (UFK), VLDB 2025 + 95% TCO proof, Nimble Robotics case study, $1,000 promo (CurrentLondon1000).',
  eventDate: '2026-05-19',
  promo: {
    eyebrow: 'Current Summit London · UFK Launch Promo',
    amount: '$1,000',
    code: 'CurrentLondon1000',
    validity: 'Tuesday 19 May 2026 through Tuesday 26 May 2026 (UTC)',
    signupUrl: 'https://console.streamnative.cloud/signup?from=event_current-summit-london-2026',
    signupDisplayUrl: 'console.streamnative.cloud/signup',
  },
};
